import Price from './price'
import Currency from './currency'

const install = (Vue, options) => {
  Vue.filter('price', Price)
  Vue.filter('currency', Currency)
}

export default { install }
